<template>
  <div class="max-w-md flex flex-col md:ml-auto">
    <popper
      v-if="canCreateComms"
      trigger="click"
      v-cloak
    >
      <div class="popper popper-simple popper-arrow z-10">
        <div class="flex flex-col">
        <a
          v-can="'create-blog-entries'"
          :href="createBlogRoute"
          class="mb-2"
          v-text="'Create New Blog Post'"
        />
        <a
          v-can="'create-email'"
          :href="createEmailRoute"
          class="mb-2"
          v-text="'Create New Email'"
        />
        <a
          v-can="'create-sms'"
          :href="createSMSRoute"
          class=""
          v-text="'Create New Text Message'"
        />
        <a
          v-can="'manage-communication-category-membership-groups'"
          :href="manageCategoriesRoute"
          class="mb-2"
          v-text="'Manage Categories'"
        />
      </div>
      </div>
      <a
        href="#"
        slot="reference"
        class="btn btn--md ml-auto"
        v-text="'Manage Communications'"
      />
    </popper>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'CommsHeader',
  data() {
    return {
      'createBlogRoute': this.$urlGenerator.active('communications/blog/create'),
      'createEmailRoute': this.$urlGenerator.active('communications/email/create'),
      'createSMSRoute': this.$urlGenerator.active('communications/sms/create'),
      'manageCategoriesRoute': this.$urlGenerator.active('communications/categories'),
    }
  },
  computed: {
    canCreateComms() {
      const abilities = this.$store.state.user.abilities

      return (
        abilities.includes('create-blog-entries') ||
        abilities.includes('create-email') ||
        abilities.includes('create-sms') ||
        abilities.includes('manage-communication-category-membership-groups')
      )
    },
  },
}
</script>
